import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Feature.css'
import template from './Feature.jinja'


var Feature = BaseView.extend({
    events: {
        'click .Feature-header': 'toggle'
    },

    initialize (options) {
        this.parent = options.parent

        this.$text = this.$('.Feature-text')
        this.$icon = this.$('.Feature-icon')
    },

    toggle() {
        this.parent.trigger('Feature-toggled', this)
    },

    activate() {
        this.$el.velocity('stop', true)
        this.$text.velocity('stop', true)
        this.$icon.velocity('stop', true)

        this.$text.css({visibility: 'hidden', display: 'block'})

        this.textH = this.$text.outerHeight()

        $.Velocity.animate(this.$el[0], {
            'margin-bottom': [this.textH, 0]
        }, {
            duration: 800,
            easing: 'linear'
        })

        $.Velocity.animate(this.$icon[0], {
            rotateZ: ['90deg', '0deg']
        }, {
            duration: 800,
            easing: 'linear'
        })

        return $.Velocity.animate(this.$text[0], {
            opacity: [1, 0]
        }, {
            visibility: 'visible',
            delay: 500,
            duration: 400,
            easing: 'linear'
        })
    },

    deactivate() {
        this.$el.velocity('stop', true)
        this.$text.velocity('stop', true)
        this.$icon.velocity('stop', true)

        $.Velocity.animate(this.$icon[0], {
            rotateZ: ['0deg', '90deg']
        }, {
            duration: 800,
            easing: 'linear'
        })

        $.Velocity.animate(this.$text[0], {
            opacity: [0, 1]
        }, {
            display: 'none',
            duration: 400,
            easing: 'linear'
        })

        return $.Velocity.animate(this.$el[0], {
            'margin-bottom': [0, this.textH]
        }, {
            duration: 800,
            easing: 'linear'
        })
    }
})

export default Feature


// WEBPACK FOOTER //
// ./assets/app/front/components/Feature/Feature.js